export default (data) => {
  let map = new Map();
  let newData = [];
  let message = null;
  data.forEach((d) => {
    const key = `${d.worksiteCity}${d.worksiteState}${d.worksiteCountyTownship}${d.worksiteBlsArea}`;
    map.set(key, d);
  });
  newData = Array.from(map, ([_, value]) => value);
  if (data.length - newData.length !== 0) {
    message = `REMOVED ${
      data.length - newData.length
    } DUPLICATE WORKSITES: WORKSITES WITH SAME CITY, STATE, COUNTY AND MSA WILL ONLY BE DISPLAYED ONCE.`;
  }
  return [newData, message];
};
